<template>
  <div v-if="results">
    <span v-if="response && response.numFound != 0" class="align-bottom">
    {{$t('paging.showing_results')}} <b>{{response.start+1}} {{$t('paging.to')}} {{response.start + results.length}}</b> {{$t('paging.of')}} <b>{{response.numFound}}</b> {{$t('paging.total')}}
    </span>
    <nav class="float-right">
    <ul class="pagination ">
      <li class="page-item" v-if="paging && paging.sem_previous_page_urls">
        <a class="page-link btn-sm" v-on:click.prevent="pagingChanged"
           v-bind:data-actionurl="this.paging.sem_previous_page_urls.sem_url_action">
           {{$t('paging.previous')}}
        </a>
      </li>
      <li class="page-item" v-if="this.paging && this.paging.sem_next_page_urls">
        <a class="page-link btn-sm" v-on:click.prevent="pagingChanged"
           v-bind:data-actionurl="this.paging.sem_next_page_urls.sem_url_action">
           {{$t('paging.next')}}
        </a>
      </li>
    </ul>
    </nav>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: 'paging',
  methods: {
    pagingChanged: function (e) {
      this.$router.push(e.srcElement.getAttribute('data-actionurl'));
      window.scrollTo(0,0);
    }
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    results () {
      if (this.$store.state.response &&
          this.$store.state.response.response &&
          this.$store.state.response.response.docs) {
        return this.$store.state.response.response.docs
      }
      return null;
    },
    paging () {
      if (this.$store.state.response &&
        this.$store.state.response.paging) {
        return this.$store.state.response.paging;
      }
      return null;
    }
  }
}
</script>

<style scoped>
</style>
